import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SearchBar from '../components/SearchBar';
import WordLists from '../components/WordLists';
import { DictionaryService } from '../services/dictionaryService';
import { usePageMeta, SITE_NAME } from '../lib/usePageMeta';

const DictionaryPage = () => {
  const [recentWords] = useState(() => DictionaryService.getRecentWords());

  usePageMeta(
    `Dictionary: Define Any English Word | ${SITE_NAME}`,
    'Search the dictionary for the definition of any English word, with pronunciation, examples and similar words.'
  );

  return (
    <div className="wrap pt-12 md:pt-16">
      <h1 className="font-serif text-4xl font-semibold tracking-[-0.01em] md:text-5xl">Dictionary</h1>
      <p className="mt-3 max-w-xl text-lg text-ink-soft">
        Search any English word for its meaning, pronunciation, examples and similar words.
      </p>
      <SearchBar variant="field" className="mt-8 max-w-2xl" placeholder="Type a word, or ask a question" autoFocus />

      {recentWords.length > 0 && (
        <section className="mt-14">
          <h2 className="font-serif text-2xl font-semibold">Your recent words</h2>
          <ul className="mt-4 flex flex-wrap gap-x-6 gap-y-2">
            {recentWords.map((word) => (
              <li key={word}>
                <Link
                  to={`/define/${encodeURIComponent(word)}`}
                  className="rounded-sm font-serif text-xl decoration-mark decoration-4 underline-offset-4 hover:underline"
                >
                  {word}
                </Link>
              </li>
            ))}
          </ul>
        </section>
      )}

      <section className="mt-16 border-t border-rule pt-12">
        <h2 className="font-serif text-2xl font-semibold">Word lists</h2>
        <p className="mt-2 text-ink-soft">Words grouped by where you’re likely to meet them.</p>
        <WordLists className="mt-8" />
      </section>
    </div>
  );
};

export default DictionaryPage;
